// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1ICuz","savePackageButton":"ClientWallet_savePackageButton__2je4v"};